import React, { useEffect, useState } from 'react';
import { useNotification } from '../contexts/NotificationContext';
import successIcon from '../assets/images/right.png';
import errorIcon from '../assets/images/cross.png';

const CustomToast = () => {
  const { notification, hideNotification } = useNotification();
  const { show, message, type } = notification;
  const [isRendered, setIsRendered] = useState(false);

  useEffect(() => {
    if (show) {
      setIsRendered(true);
    } else {
      const timer = setTimeout(() => setIsRendered(false), 300); // Wait for transition
      return () => clearTimeout(timer);
    }
  }, [show]);

  if (!isRendered) return null;

  const isError = type === 'error';
  const bgColor = isError ? '#FCA5A5' : '#9AE6B4';
  const textColor = isError ? '#7D4300' : '#065F46';
  const icon = isError ? errorIcon : successIcon;

  return (
    <div
      className={`custom-toast-container ${show ? 'show' : 'hide'}`}
      style={{
        position: 'fixed',
        top: '70px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        width: 'auto',
        // minWidth: '450px',
        // maxWidth: '90%',
        backgroundColor: bgColor,
        color: textColor,
        padding: '16px 24px',
        borderRadius: '8px',
        boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
        display: 'flex',
        alignItems: 'center',
        gap: '15px',
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        opacity: show ? 1 : 0,
        marginTop: show ? '0' : '-20px',
        cursor: 'pointer'
      }}
      onClick={hideNotification}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          hideNotification();
        }
      }}
      role="button"
      tabIndex={0}
      aria-live="assertive"
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '24px', height: '24px' }}>
        <img src={icon} alt={isError ? 'Error' : 'Success'} style={{ width: '100%', height: '100%' }} />
      </div>
      <div style={{ fontSize: '15px', fontWeight: '700', flex: 1, letterSpacing: '0.3px' }}>{message}</div>
    </div>
  );
};

export default CustomToast;
